export default __webpack_public_path__ + "static/media/thin-edit-dark.4278b07e.svg";